"use client";

import { Badge } from "@/components/ui/badge";
import { CheckCircle } from "lucide-react";
import Image from "next/image";

export default function Story() {
  return (
    <section className={"wrapper py-10 square-gradient-bg"}>
      <div className={"flex flex-col gap-5 "}>
        <Badge>Our Story</Badge>
        <h1 className={"text-4xl font-bold"}>
          Building Bhutan&apos;s <br />{" "}
          <span className={"text-primary"}>Technological Future</span>
        </h1>
        <div className={"flex justify-between flex-col md:flex-row gap-5"}>
          <div className={"flex-1 grid text-lg gap-5 font-semibold"}>
            <p>
              VisionTech Trading was established with a clear mission: to bridge
              the gap between global technological innovations and Bhutan&apos;s
              growing market needs. As one of the leading trading houses in
              Bhutan, we have consistently delivered cutting-edge solutions
              across multiple sectors.
            </p>
            <p>
              Our journey began in Thimphu, and today we operate from multiple
              locations across Bhutan while maintaining strategic international
              offices in Kolkata, Bangkok, and Singapore. This global network
              enables us to source the best products and technologies from
              around the world.
            </p>
            <p>
              We believe that technology has the power to transform societies,
              and our commitment lies in making these transformative
              technologies accessible to businesses and institutions across
              Bhutan and the region.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-2">
                <CheckCircle className="h-6 w-6 text-primary" />
                <h3 className="font-semibold text-primary">Global Network</h3>
                <p className="text-muted-foreground text-sm">
                  International partnerships across Asia
                </p>
              </div>
              <div className="space-y-2">
                <CheckCircle className="h-6 w-6 text-primary" />
                <h3 className="font-semibold text-primary">Quality Assured</h3>
                <p className="text-muted-foreground text-sm">
                  Premium products meeting international standards
                </p>
              </div>
            </div>
          </div>
          <Image
            src={
              "https://st3.depositphotos.com/3591429/13202/i/450/depositphotos_132028712-stock-photo-diverse-people-at-the-meeting.jpg"
            }
            alt={"Office"}
            width={500}
            height={500}
            className={
              "max-w-1/2 sticky top-[6rem] h-full object-cover rounded"
            }
          />
        </div>
      </div>
    </section>
  );
}
